<template>
  <layout-auth>
    <v-container class="py-10">
      <v-row>
        <v-col cols="8">
          <h1 class="text-h4 font-weight-light">
            {{ $t("invoices.aticiposFacturas") }}
          </h1>
        </v-col>
      </v-row>
      <v-divider :color="entityConfig.primaryColor"></v-divider>
    </v-container>

    <v-container>
      <v-form v-model="formulario" ref="formulario" autocomplete="off">
        <v-row>
          <v-col cols="10" sm="12" md="6" lg="8">
            <label class="label-negrita py-5">{{
              $t("invoices.empresaEmisor")
            }}</label>

            <v-autocomplete
              :rules="[rules.required2]"
              hint="  Es obligatorio seleccionar el nombre de cliente para visualizar el listado de facturas"
              placeholder="Seleccionar nombre de cliente"
              :color="entityConfig.primaryColor"
              :item-color="entityConfig.primaryColor"
              :items="clientList"
              dense
              no-data-text=""
              item-text="name"
              item-value="numClient"
              outlined
              @change="filterNumeroClients"
              v-model="form.selectedClient"
            ></v-autocomplete>
          </v-col>
          <v-col cols="2" sm="4" md="4" lg="4">
            <v-icon
              @click="mostrarTabla = !mostrarTabla"
              class="float-end"
              left
            >
              mdi-close
            </v-icon>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" md="3" lg="2">
            <label class="label-negrita py-5">{{
              $t("invoices.fechaVencimiento")
            }}</label>

            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  readonly
                  outlined
                  dense
                  :rules="[rules.dateFrom]"
                  :placeholder="$t('invoices.from')"
                  v-model="dateFromFormatted"
                  :color="entityConfig.primaryColor"
                  persistent-hint
                  @blur="$refs.formulario.validate()"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :max="DateMax"
                :min="DateMin"
                :locale="$i18n.locale"
                :color="entityConfig.primaryColor"
                v-model="form.dateInit"
                @input="filterFechaDesde"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <label class="label-negrita py-7"></label>

            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  readonly
                  outlined
                  dense
                  :rules="[rules.dateFrom]"
                  :placeholder="$t('invoices.to')"
                  v-model="dateToFormatted"
                  :color="entityConfig.primaryColor"
                  persistent-hint
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :max="DateMax"
                :min="DateMin"
                :locale="$i18n.locale"
                :color="entityConfig.primaryColor"
                v-model="form.dateEnd"
                @input="filterFechaHasta"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="6" md="3" lg="2">
            <label class="label-negrita py-5">{{
              $t("invoices.importeFactura")
            }}</label>
            <v-currency-field
              maxlength="18"
              :rules="[rules.amountFrom, rules.quinceEnterosInit]"
              :color="entityConfig.primaryColor"
              dense
              @input="filterImporteDesde"
              @keyup="$refs.formulario.validate()"
              outlined
              :placeholder="$t('invoices.from')"
              appendIcon="mdi-currency-eur"
              append-icon="mdi-euro"
              v-model="form.invoiceAmountInit"
            />
          </v-col>

          <v-col cols="12" sm="6" md="3" lg="2">
            <label class="label-negrita py-7"></label>
            <v-currency-field
              maxlength="18"
              :rules="[rules.amountFrom, rules.quinceEnterosEnd]"
              :color="entityConfig.primaryColor"
              dense
              @input="filterImporteHasta"
              @keyup="$refs.formulario.validate()"
              outlined
              :placeholder="$t('invoices.to')"
              appendIcon="mdi-currency-eur"
              append-icon="mdi-euro"
              v-model="form.invoiceAmountEnds"
            />
          </v-col>

          <v-col cols="12" sm="12" lg="4" v-show="entityConfig.tipoConfirming">
            <label class="label-negrita py-5">{{
              $t("invoices.tipoConfirming")
            }}</label>
            <v-select
              :rules="[rules.required]"
              :color="entityConfig.primaryColor"
              :item-color="entityConfig.primaryColor"
              :items="tipoConfirming"
              dense
              outlined
              placeholder="Normal"
              item-text="name"
              item-value="value"
              v-model="form.tipoConfirming"
              @change="filterTipoConfirming"
            ></v-select>
          </v-col>
        </v-row>

        <v-row class="py-10" style="padding-bottom: 8%">
          <v-col cols="12" sm="12" lg="12">
            <v-btn
              depressed
              @click="getListOfAnticipatedInvoices()"
              :color="entityConfig.primaryColor"
              :disabled="!formIsValid"
              :style="`color: ${entityConfig.secondaryColor}`"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("invoices.filtrar") }}
            </v-btn>

            <v-btn
              outlined
              @click="
                limpiarFiltros();
                mostrarTabla = true;
              "
              :color="entityConfig.primaryColor"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("invoices.quitarFiltros") }}
            </v-btn>
          </v-col>
        </v-row>

        <overlay :visible="spinner" :opacity="1"></overlay>
      </v-form>
    </v-container>

    <v-container v-show="mostrarTabla">
      <v-form v-model="formulario2" autocomplete="off">
        <v-divider :color="entityConfig.primaryColor"></v-divider>
        <v-row>
          <v-col cols="3">
            <h2 class="text-h6 font-weight-light">
              {{ $t("invoices.listadoFacturas") }}
            </h2>
          </v-col>

          <v-col>
            <v-btn
              plain
              :color="entityConfig.primaryColor"
              class="float-end m-2"
              @click="print()"
            >
              <v-icon left> mdi-printer-outline </v-icon>
              {{ $t("supplierData.print") }}
            </v-btn>

            <v-btn
              plain
              :color="entityConfig.primaryColor"
              @click="downloadExcel"
              class="float-end m-2"
            >
              <v-icon left> mdi-microsoft-excel </v-icon>
              Excel
            </v-btn>

            <v-autocomplete
              :rules="[rules.required]"
              item-text="iban"
              item-value="iban"
              class="float-end m-2"
              no-data-text=""
              placeholder="ES36 2028 4343 1976"
              :color="entityConfig.primaryColor"
              :item-color="entityConfig.primaryColor"
              :items="cuentasDeAbono"
              @change="simulationModel.iban = cuentaDeAbonoSeleccionada"
              v-model="cuentaDeAbonoSeleccionada"
              dense
              outlined
            ></v-autocomplete>

            <label class="float-end m-2 py-2">{{
              $t("invoices.cuentaAbono")
            }}</label>
          </v-col>
        </v-row>
        <v-divider :color="entityConfig.primaryColor"></v-divider>
        <error-table :erroCode="valCode" :hidden="!noData" />
        <v-data-table
          :hidden="noData"
          fixed-header
          no-data-text="No hay datos que mostrar"
          v-model="simulationModel.selectedInvoices"
          class="firt-col-right-margin"
          :single-select="false"
          :checkbox-color="entityConfig.primaryColor"
          item-key="invoiceNumberExt"
          show-select
          :headers="headers"
          :items="anticipatedInvoices"
          hide-default-footer
          :items-per-page="50"
        >
          <template v-slot:item.invoiceDate="{ item }">
            {{ dataFormatter.dateFormatter(item.invoiceDate, $i18n.locale) }}
          </template>
          <template v-slot:item.invoiceExpirationDate="{ item }">
            {{
              dataFormatter.dateFormatter(
                item.invoiceExpirationDate,
                $i18n.locale
              )
            }}
          </template>

          <template v-slot:item.nominalAmount="{ item }">
            {{ dataFormatter.currencyFormatter(item.nominalAmount) }}
          </template>

          <template v-slot:item.nominalAmountFinanced="{ item }">
            <strong>{{
              dataFormatter.currencyFormatter(item.nominalAmountFinanced)
            }}</strong>
          </template>

          <template v-slot:item.newNominalAmountFinanced="{ item }">
            <my-v-currency-field
              class="imp-anticipable"
              :color="entityConfig.primaryColor"
              :placeholder="$t('invoices.Importe')"
              dense
              outlined
              appendIcon="mdi-currency-eur"
              type="number"
              :rules="[
                (v) =>
                  item.newNominalAmountFinanced <= item.nominalAmountFinanced ||
                  'Monto debe ser menor al importe anticipable',
              ]"
              v-model="item.newNominalAmountFinanced"
            />
          </template>
        </v-data-table>

        <v-row :hidden="noData" class="py-5">
          <v-col cols="12" sm="12" lg="12">
            <v-btn
              @click="resumenAnticipo(true)"
              plain
              :disabled="!hasSelectedItems || !formulario2"
              :color="entityConfig.primaryColor"
              class="float-end m-2 v-btn-width-default"
            >
              <v-icon left> mdi-chat-question </v-icon>
              {{ $t("invoices.simulation") }}
            </v-btn>
          </v-col>
          <v-col cols="12" sm="12" lg="12">
            <v-btn
              :disabled="!hasSelectedItems || !formulario2"
              @click="resumenAnticipo(false)"
              depressed
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("invoices.requestAdvance") }}
            </v-btn>
          </v-col>
        </v-row>

        <overlay :visible="spinner" :opacity="1"></overlay>
      </v-form>
    </v-container>

    <v-dialog v-model="dialogNoAccounts" persistent max-width="500">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <p class="text-body-1">
            Para realizar operaciones de anticipo de facturas debe tener al
            menos una <em>Cuenta de Abono</em> validada.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            dark
            depressed
            :color="entityConfig.primaryColor"
            :style="`color: ${entityConfig.secondaryColor}`"
            @click="dialogNoAccounts = false"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </layout-auth>
</template>

<script>
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import Overlay from "../../components/layouts/overlay.vue";
import MyVCurrencyField from "../../components/global/MyVCurrencyField.vue";
import dataFormatter from "../../plugins/dataFormatter";
import Api from "../../Services/index";
import xlsx from "json-as-xlsx";
import ErrorTable from "../../components/layouts/error-table.vue";
import { createToastInterface } from "vue-toastification";

export default {
  components: { LayoutAuth, Overlay, MyVCurrencyField, ErrorTable },
  data() {
    return {
      noData: false,
      valCode: 0,
      entityConfig: {},
      simulationModel: {
        iban: "",
        selectedInvoices: [],
        client: {
          numCliente: "",
          name: "",
        },
      },
      autoDecimalMode: true,
      dialogNoAccounts: false,
      dataFormatter: dataFormatter,
      cuentaDeAbonoSeleccionada: "",
      formulario: false,
      formulario2: false,
      mostrarTabla: false,
      spinner: true,
      clientList: [],
      tipoConfirming: [
        { value: "N", name: this.$t("invoices.normal") },
        { value: "D", name: this.$t("invoices.gastoDeudor") },
      ],
      situacionFactura: [
        { value: 0, name: this.$t("invoices.everySituation") },
        { value: 1, name: this.$t("invoices.anticipated") },
        { value: 2, name: this.$t("invoices.pendingConfirmation") },
        { value: 3, name: this.$t("invoices.pendingTramit") },
        { value: 4, name: this.$t("invoices.paidOnExpiration") },
      ],
      menu1: false,
      menu2: false,
      form: {
        selectedClient: "",
        dateInit: "",
        dateEnd: "",
        invoiceAmountInit: "",
        invoiceAmountEnds: "",
        tipoConfirming: "N",
        situacionFactura: "",
      },
      userId: "",
      userdata: {},

      query: {
        codigoEntidad: "",
        tipoConfirming: "",
        numCliente: "",
      },
      headers: [
        {
          text: this.$t("invoices.invoiceNumber"),
          sortable: false,
          value: "invoiceNumberExt",
        },
        {
          text: this.$t("invoices.client"),
          sortable: false,
          value: "customerName",
        },
        {
          text: this.$t("invoices.date"),
          sortable: false,
          value: "invoiceDate",
          align: "right",
        },
        {
          text: this.$t("invoices.expDate"),
          sortable: false,
          value: "invoiceExpirationDate",
          align: "right",
        },
        {
          text: this.$t("invoices.nominalAmount"),
          sortable: false,
          value: "nominalAmount",
          align: "right",
        },
        {
          text: this.$t("invoices.IMPANTICIPABLE"),
          sortable: false,
          value: "nominalAmountFinanced",
          align: "right",
        },
        {
          text: this.$t("invoices.anticipable"),
          sortable: false,
          value: "newNominalAmountFinanced",
          width: "12em",
        },
      ],
      anticipatedInvoices: [],
      cuentasDeAbono: [],
      clientListSeleccionada: [],
      rules: {
        required: (value) => !!value || "Este campo es requerido..",

        required2: (value) =>
          !!value ||
          "Este campo es requerido Es obligatorio seleccionar el nombre de cliente para visualizar el listado de facturas",

        requiredName: (value) =>
          !!value ||
          " Es obligatorio seleccionar el nombre de cliente para visualizar el listado de facturas",
        dateFrom: () => {
          if (this.form.dateInit !== "" && this.form.dateEnd !== "") {
            var fecha1 = new Date(this.form.dateInit);
            var fecha2 = new Date(this.form.dateEnd);
            return (
              fecha1.getTime() <= fecha2.getTime() ||
              "Fecha de vencimiento desde debe ser menor a fecha hasta."
            );
          }
          return true;
        },
        quinceEnterosInit: () =>
          this.form.invoiceAmountInit < 1000000000000000 ||
          "El importe no debe contener mas de quince enteros y dos decimales",
        quinceEnterosEnd: () =>
          this.form.invoiceAmountEnds < 1000000000000000 ||
          "El importe no debe contener mas de quince enteros y dos decimales",
        amountFrom: () => {
          if (
            this.form.invoiceAmountInit !== "" &&
            this.form.invoiceAmountEnds !== "" &&
            this.form.invoiceAmountInit !== null &&
            this.form.invoiceAmountEnds !== null
          ) {
            return (
              this.form.invoiceAmountInit <= this.form.invoiceAmountEnds ||
              "El importe hasta debe ser mayor al importe desde."
            );
          }
          return true;
        },
      },
    };
  },

  async mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    this.userdata = JSON.parse(sessionStorage.getItem("userData"));
    this.userId = this.userdata.supplierId.trim();
    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");

    this.query.tipoConfirming = "N";
    this.query.codigoEntidad = sessionStorage.getItem("codNrbeEn");

    await this.getListOfAccountNumbers();
    await this.getListOfClients();
    await this.getListOfAnticipatedInvoices();

    if (/true/i.test(this.$route.query.goBack)) {
      this.initializarVistaConBotonBack();
    } else {
      sessionStorage.removeItem("formAnticitpo");
      sessionStorage.removeItem("invoicesAnticipo");
      sessionStorage.removeItem("simulationModel");
    }
  },

  computed: {
    hasSelectedItems() {
      return this.simulationModel.selectedInvoices.length > 0;
    },
    DateMax() {
      const dateFechaMax = new Date();
      dateFechaMax.setDate(dateFechaMax.getDate() + 365);
      return dateFechaMax.toISOString().substr(0, 10);
    },
    DateMin() {
      const dateFechaMin = new Date();
      dateFechaMin.setDate(dateFechaMin.getDate() - 365);
      return dateFechaMin.toISOString().substr(0, 10);
    },
    formIsValid() {
      return this.formulario;
    },
    formIsValid2() {
      return this.formulario2;
    },
    dateFromFormatted() {
      return this.formatDate(this.form.dateInit);
    },
    dateToFormatted() {
      return this.formatDate(this.form.dateEnd);
    },
  },
  methods: {
    downloadExcel() {
      let data = [
        {
          sheet: "Anticipo de facturas",
          columns: [
            {
              label: this.$t("invoices.NumeroFactura"),
              value: "invoiceNumberExt",
            },
            {
              label: this.$t("invoices.clientePagador"),
              value: "customerName",
            },
            { label: this.$t("invoices.fechaFactura"), value: "invoiceDate" },
            {
              label: this.$t("invoices.FECHAVTO"),
              value: "invoiceExpirationDate",
            },
            { label: this.$t("invoices.IMPFACTURA"), value: "nominalAmount" },
            {
              label: this.$t("invoices.IMPANTICIPABLE"),
              value: "nominalAmountFinanced",
            },
          ],
          content: this.anticipatedInvoices,
        },
      ];
      let settings = { fileName: "Anticipo de facturas" };
      xlsx(data, settings);
    },
    print() {
      window.print();
    },
    validateAmounts() {
      let i = 0;
      this.simulationModel.selectedInvoices.forEach((e) => {
        if (e.newNominalAmountFinanced > e.nominalAmountFinanced) {
          i++;
        }
      });
      return i > 0;
    },
    resumenAnticipo(isAnticipo) {
      if (this.validateAmounts()) {
        this.$toast.error(
          "El importe a anticipar no debe ser mayor al importe anticipable"
        );
        return;
      }
      this.simulationModel.client.numCliente =
        this.simulationModel.selectedInvoices[0].customerNumber;
      this.simulationModel.client.name =
        this.simulationModel.selectedInvoices[0].customerName;
      this.simulationModel.iban = this.cuentaDeAbonoSeleccionada;
      sessionStorage.setItem("formAnticitpo", JSON.stringify(this.form));
      sessionStorage.setItem(
        "invoicesAnticipo",
        JSON.stringify(this.anticipatedInvoices)
      );
      sessionStorage.setItem(
        "simulationModel",
        JSON.stringify(this.simulationModel)
      );
      this.$router.push({
        name: "InvoiceAdvanceConfirm",
        query: { isSimulation: isAnticipo },
      });
    },
    filterSituacionFactura(val) {
      this.query.estadoFactura = val;
    },
    filterTipoConfirming(val) {
      this.query.tipoConfirming = val;
    },

    filterFechaHasta(val) {
      this.menu2 = false;
      this.query.fechaHasta = val;
      this.$refs.formulario.validate();
    },

    filterFechaDesde(val) {
      this.menu1 = false;
      this.query.fechaDesde = val;
      this.$refs.formulario.validate();
    },

    filterImporteHasta() {
      this.query.impHasta = this.form.invoiceAmountEnds;
    },
    filterImporteDesde() {
      this.query.impDesde = this.form.invoiceAmountInit;
    },
    filterNumeroClients() {
      this.query.numCliente = this.form.selectedClient;
    },

    initializarVistaConBotonBack() {
      this.form = JSON.parse(sessionStorage.getItem("formAnticitpo"));
      this.anticipatedInvoices = JSON.parse(
        sessionStorage.getItem("invoicesAnticipo")
      );
      this.simulationModel = JSON.parse(
        sessionStorage.getItem("simulationModel")
      );
      this.query.numCliente = this.form.selectedClient;
      this.query.tipoConfirming = this.form.tipoConfirming;
      if (this.form.dateInit) {
        this.query.fechaDesde = this.formatDate(this.form.dateInit);
      }
      if (this.form.dateEnd) {
        this.query.fechaHasta = this.formatDate(this.form.dateEnd);
      }
      if (this.form.invoiceAmountInit) {
        this.query.impDesde = this.form.invoiceAmountInit;
      }
      if (this.form.invoiceAmountEnds) {
        this.query.impHasta = this.form.invoiceAmountEnds;
      }

      this.cuentaDeAbonoSeleccionada = this.simulationModel.iban;
      this.mostrarTabla = true;
    },

    limpiarFiltros() {
      this.query = {};
      this.query.tipoConfirming = "N";
      this.query.codigoEntidad = sessionStorage.getItem("codNrbeEn");

      sessionStorage.removeItem("formAnticitpo");
      sessionStorage.removeItem("invoicesAnticipo");
      sessionStorage.removeItem("simulationModel");
      this.cuentaDeAbonoSeleccionada = this.cuentasDeAbono[0].iban;
      this.simulationModel = {
        iban: "",
        selectedInvoices: [],
        client: {
          numCliente: "",
          name: "",
        },
      };

      this.form = {
        selectedClient: "",
        dateInit: "",
        dateEnd: "",
        invoiceAmountInit: null,
        invoiceAmountEnds: null,
        situacionFactura: "",
        tipoConfirming: "N",
      };
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${day}-${month}-${year}`;
    },

    async getListOfAnticipatedInvoices() {
      this.mostrarTabla = false;
      this.simulationModel = {
        iban: "",
        selectedInvoices: [],
        client: {
          numClient: "",
          name: "",
        },
      };
      const qs = Object.keys(this.query)
        .filter((key) => this.query[key])
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(this.query[key])}`
        )
        .join("&");
      try {
        this.autoDecimalMode = true;
        this.userdata = JSON.parse(sessionStorage.getItem("userData"));
        this.userId = this.userdata.supplierId.trim();
        this.spinner = true;

        let invoicesResponse = await Api.get(
          `/proveedores/${this.userId}/facturas-financiables/?${qs}`
        );
        this.anticipatedInvoices = [];
        let invoices = invoicesResponse.data.response.invoicePendingDetailsDtoList;

        if (invoicesResponse.data.response.moreData) {
          const myToast = createToastInterface();
          myToast.success(this.$t("invoices.moreDataMessage"), {
            timeout: 60000,
            hideProgressBar: true,
          });
        }        

        for (let i = 0; i < invoices.length; i++) {
          invoices[i].newNominalAmountFinanced = invoices[i].nominalAmountFinanced;
        }
        this.anticipatedInvoices = invoices;
        this.mostrarTabla = true;
        this.noData = false;
      } catch (error) {
        this.valCode = error.response.data.code;
        this.noData = true;
        this.mostrarTabla = true;
      } finally {
        this.spinner = false;
        this.autoDecimalMode = false;
      }
    },
    async getListOfClients() {
      try {
        this.userdata = JSON.parse(sessionStorage.getItem("userData"));
        this.userId = this.userdata.supplierId.trim();
        this.spinner = true;

        let clientResponse = await Api.get(
          `/proveedores/${this.userId}/clientes`
        );
        this.clientList = clientResponse.data.response;

        if (!this.form.selectedClient) {
          this.form.selectedClient = this.clientList[0].numClient;
          this.query.numCliente = this.form.selectedClient;
        }
      } catch (error) {
        this.$showError(this, error.response.data);
      } finally {
        this.spinner = false;
      }
    },
    async getListOfAccountNumbers() {
      try {
        this.userdata = JSON.parse(sessionStorage.getItem("userData"));
        this.userId = this.userdata.supplierId.trim();
        this.spinner = true;

        let response = await Api.get(
          `/proveedores/${this.userId}/cuentas-abono-total`
        );
        this.cuentasDeAbono = response.data.response;
        if (this.cuentasDeAbono && (this.cuentasDeAbono.length > 0)) {
          if (!this.cuentaDeAbonoSeleccionada) {
            this.cuentaDeAbonoSeleccionada = this.cuentasDeAbono[0].iban;
          }
        } else {
          this.dialogNoAccounts = true;
        }        
      } catch (error) {
        this.dialogNoAccounts = true;
      } finally {
        this.spinner = false;
      }
    },
  },
};
</script>
